var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"entityModalViewer"},[_c('em-entity-viewer',{attrs:{"entity":_vm.entity,"object":_vm.object,"title":_vm.title,"$_em-custom-vuex-mixin_configs":_vm.$_emCustomVuexMixin_configs,"asCard":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }